import PortalIdParser from 'PortalIdParser';
import { getFullUrl } from 'hubspot-url-utils';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
export const PaidPopupFormDeprecation = () => /*#__PURE__*/_jsx(Alert, {
  titleText: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "popupFormsBanner.deprecationNotice.paid.title"
  }),
  type: "warning",
  children: /*#__PURE__*/_jsx(Text, {
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "popupFormsBanner.deprecationNotice.paid.description_jsx",
      options: {
        linkProps: {
          href: `${getFullUrl('app')}/calls-to-action/${PortalIdParser.get()}/manage/state/all`,
          external: true
        },
        date: {
          value: '2025-06-04',
          format: 'LL'
        }
      },
      elements: {
        Link,
        FormattedDateTime
      }
    })
  })
});